unit NetListScreenType;
{

/* Initial. */

}
interface

uses
  NetItemListType;

type
  TNetListScreenType = class
  private
    fNetItemList: TNetItemListType;
  public
    property NetItemList: TNetItemListType read fNetItemList;
  end;

implementation

end.
